module.exports = __webpack_public_path__ + "img/alicia_baner.4ed0ee81.png";